module.exports = "#define GLSLIFY 1\nuniform sampler2D fontTexture;\n\nvarying vec4 vTextCoord;\nvarying vec2 vUv;\nvarying vec4 vColor;\n\nvoid main(){\n\n  if (vColor.a < 0.1) {\n    discard;\n  }\n\n  float x = vTextCoord.x + vUv.x * vTextCoord.z;\n  float y = vTextCoord.y + (1. - vUv.y) * vTextCoord.w;\n  vec4 color = texture2D(fontTexture, vec2(x,y));\n\n  color *= vColor;\n\n  gl_FragColor = color;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/libs/geometry/text/shaders/text.frag
// module id = 441
// module chunks = 0